export default {
    components: {
        carat: "Karat",
        shape: "Form",
        cut: "Schliff",
        color: "Farbe",
        clarity: "Reinheit",
        noSelection: "Keine Auswahl",
        gia: `Alle Unsere Diamanten werden von dem Gemological
        Institute of America geprüft. Klicke
        <a target="_blank" rel="noopener noreferrer" href="{url}">hier</a> um das Zertifikat
        für deinen gewählten Diamanten anzuzeigen.`,
        gia2: `<a target="_blank" rel="noopener noreferrer" href="{url}">Link zum Zertifikat</a>`,
        ct: "KT",
        yourSelection: "Deine Auswahl",
        ringband: "Ringschiene",
        price: "Preis",
        total: "Gesamt",
        highlighted: "Angebot",
        noImageHeading: "Kein Bild verfügbar",
        noImageParagraph:
            "Für deinen gewählten Diamanten leigt leider kein Bild vor.",
        selectDiamondHeading: "Wähle einen Diamanten",
        selectDiamondParagraph:
            "Wähle einen Diamanten im Diamond Finder um hier Detailinformationen angezeigt zu bekommen.",
        buyButtonLabel: "In den Warenkorb",
    },
    singleDiamondsConfigurator: {
        heading: "Diamond Finder",
        compareHeading: "Im Vergleich",
        clarityDiagramHeading: "Reinheitsskala",
        colorDiagramHeading: "Farbskala",
        comparableDiamonds: {
            currentHeading: "Aktuelle Auswahl",
            moreCarat: "Mehr Karat",
            betterColor: "Bessere Farbe",
            higherClarity: "Höhere Reinheit",
        },
        priceLabel: "Preis deiner Auswahl",
    },
    diamondProperties: {
        shape: {
            AS: "Asscher",
            BAG: "Baguette",
            CB: "Cushion Brilliant",
            CU: "Cushion",
            EM: "Emerald",
            HS: "Heart",
            MQ: "Marquise",
            OV: "Oval",
            PR: "Princess",
            PS: "Pear",
            RA: "Radiant",
            RD: "Brilliant",
            TRIL: "Trilliant",
        },
        color: {
            D: "Hochfeines Weiß +",
            E: "Hochfeines Weiß",
            F: "Feines Weiß +",
            G: "Feines Weiß",
            H: "Weiß",
            I: "Leicht getöntes Weiß",
            J: "Leicht getöntes Weiß",
            K: "Getöntes Weiß",
            L: "Getönt",
            M: "Getönt",
            N: "Getönt",
        },
        clarity: {
            FL: "Fehlerfrei (FL)",
            IF: "Lupenrein (IF)",
            VVS1: "Sehr, sehr kleine Einschlüsse (VVS1)",
            VVS2: "Sehr, sehr kleine Einschlüsse (VVS2)",
            VS1: "Sehr kleine Einschlüsse (VS1)",
            VS2: "Sehr kleine Einschlüsse (VS2)",
            SI1: "Kleine Einschlüsse (SI1)",
            SI2: "Kleine Einschlüsse (SI2)",
            I1: "Einschlüsse (I1)",
            I2: "Einschlüsse (I2)",
            I3: "Einschlüsse (I3)",
        },
        cut: {
            EX: "Excellent",
            F: "Fair",
            G: "Good",
            GD: "Good",
            ID: "Ideal",
            P: "Poor",
            VG: "Very Good",
        },
        polish: {
            EX: "Excellent",
            EXCELLENT: "Excellent",
            F: "Fair",
            G: "Good",
            GD: "Good",
            GOOD: "Good",
            "VERY GOOD": "Very Good",
            VG: "Very Good",
        },
        symmetry: {
            EX: "Excellent",
            EXCELLENT: "Excellent",
            F: "Fair",
            FAIR: "Fair",
            G: "Good",
            GD: "Good",
            GOOD: "Good",
            "VERY GOOD": "Very Good",
            VG: "Very Good",
        },
        fluorescence: {
            Faint: "Faint",
            FNT: "Faint",
            MDBLUE: "Medium Blue",
            MED: "Medium",
            Medium: "Medium",
            NON: "None",
            None: "None",
            STG: "Strong",
            Strong: "Strong",
            "Very Slight": "Very Slight",
            VST: "Very Slight",
        },
    },
    diagrams: {
        colorLink:
            "https://cdn.shopify.com/s/files/1/0348/7101/7603/files/Diamond_Color_de.png?v=1694515903",
        clarityLink:
            "https://cdn.shopify.com/s/files/1/0348/7101/7603/files/Diamond_Clarity_de.png?v=1694515869",
    },
    "stockAvailable": "Sofort Verfügbar.",
    "stockLow": "Nur noch wenige verfügbar.",
    "noStock": "Derzeit ausverkauft.",
    "defaultDeliveryText": "Versandfertig in ca. 1 - 2 Werktagen.",
    "customDeliveryText": "Versandfertig in ca. {time} {unit}.",
    "deliveryUnitDays": "Werktagen",
    "deliveryUnitWeeks": "Wochen",
};
